import { render } from "./ThemePickerPopup.vue?vue&type=template&id=4783f38d"
import script from "./ThemePickerPopup.vue?vue&type=script&lang=js"
export * from "./ThemePickerPopup.vue?vue&type=script&lang=js"

import "./ThemePickerPopup.vue?vue&type=style&index=0&id=4783f38d&lang=css"
script.render = render

export default script